export const OBJECT_LIST_UPDATE_SELECTION = 'OBJECT_LIST_UPDATE_SELECTION';

export const objectListUpdateSelection = (payload) => ({
  type: OBJECT_LIST_UPDATE_SELECTION,
  payload,
});
